import { useAppTranslation } from '../i18n/useAppTranslation';
import { Link } from "react-router-dom";
import { Android, Apple, ArrowForward } from "@mui/icons-material";
import "./MobileDownload.css";
export default function MobileDownload() {
  const { tr } = useAppTranslation();
  return (
    <section
      id="mobile"
      className="landing-shell section-space mobile-download"
      aria-labelledby="mobile-title"
    >
      <div>
        <span className="mobile-eyebrow">
           {tr("VOTRE COACHING, PARTOUT AVEC VOUS")} </span>
        <h2 id="mobile-title">
          G1Sport.
          <br />
           {tr("Sur votre écran d’accueil.")} </h2>
        <p>
           {tr("Vos séances, vos progrès et votre coach à portée de main. Installez G1Sport directement depuis le site, sans passer par un store.")} </p>
        <div className="desktop-install-note">
          <strong>{tr("Disponible aussi sur PC et Mac")}</strong>
          <p>
             {tr("Depuis un ordinateur, ces liens installent G1Sport sur cet ordinateur. Pour votre téléphone, scannez l’un des QR codes.")} </p>
          <Link to="/installer?platform=desktop">
             {tr("Installer sur PC ou Mac")} <ArrowForward fontSize="small" />
          </Link>
        </div>
        <div className="mobile-benefits">
          <span>{tr("Votre icône G1Sport")}</span>
          <span>{tr("Une fenêtre dédiée")}</span>
          <span>{tr("Compte et données synchronisés")}</span>
        </div>
        <small>
           {tr("Installation gratuite. Une connexion Internet est nécessaire pour utiliser les fonctionnalités.")} </small>
      </div>
      <div className="mobile-download-cards">
        {(["android", "ios"] as const).map((os) => (
          <article className="mobile-download-card" key={os}>
            <h3>
              {os === "android" ? <Android /> : <Apple />}
              {os === "android" ? "Android" : "iPhone / iPad"}
            </h3>
            <img
              src={"/qr-" + os + ".svg"}
              width="176"
              height="176"
              alt={
                tr("QR code pour installer G1Sport sur {platform}", { platform: os === "android" ? "Android" : "iPhone / iPad" })
              }
              loading="lazy"
            />
            <p>{tr("Scannez avec l’appareil photo de votre téléphone.")}</p>
            <Link to={"/installer?platform=" + os}>
               {tr("Installer sur")} {os === "android" ? "Android" : "iOS"}{" "}
              <ArrowForward fontSize="small" />
            </Link>
            <small>
              {os === "android"
                ? tr("Avec Chrome ou un navigateur compatible")
                : tr("Safari, Chrome et navigateurs iOS compatibles")}
            </small>
          </article>
        ))}
      </div>
    </section>
  );
}
